import styled from 'styled-components';

// This page has no form, just a status message, so the lock icon stands in
// for the inputs the other auth cards show.
export const LockIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 72px;
  height: 72px;
  margin: 0 auto 20px;

  background-color: var(--light-pink);
  border-radius: 50%;

  svg path {
    fill: var(--primary);
  }
`;
